import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  RdsAvatarComponent,
  RdsAvatarIconDirective,
  RdsAvatarImageDirective,
  RdsBadgeComponent,
  RdsCustomIconComponent,
  RdsIconComponent,
} from '@rds/angular-components';

import { convertServicesToViewModel } from '../../../../../../bookly-user/src/lib/booking-request/services/booking.service';
import {
  BookingRequestDetailsModel,
  ServiceViewModel,
} from '../../../booking-request';
import { EventDateTimePipe } from '../../../core';

@Component({
  selector: 'bsh-booking-summary',
  imports: [
    RdsIconComponent,
    EventDateTimePipe,
    RdsAvatarComponent,
    RdsAvatarImageDirective,
    RdsAvatarIconDirective,
    RdsCustomIconComponent,
    NgOptimizedImage,
    RdsBadgeComponent,
  ],
  templateUrl: './booking-summary.component.html',
  styleUrl: './booking-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingSummaryComponent {
  @Input() set bookingDetails(details: BookingRequestDetailsModel) {
    this.selectedServices = convertServicesToViewModel(details.services || []);
    this.details = details;
  }
  @Input() set generalQuestionsEnabled(generalQuestionsEnabled: boolean) {
    this.showGeneralQuestions = generalQuestionsEnabled;
  }
  @Input() siteTimeZone: string | null = null;

  protected showGeneralQuestions: boolean | null = null;
  protected details: BookingRequestDetailsModel | null = null;
  protected selectedServices: ServiceViewModel[] = [];
}
